var _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColleges1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.69 21.873c0 11.99-9.72 21.71-21.71 21.71-11.989 0-21.705-9.72-21.705-21.71S9.995.163 21.985.163s21.71 9.72 21.71 21.71h-.005Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.69 21.873c0 11.99-9.72 21.71-21.71 21.71-11.989 0-21.705-9.72-21.705-21.71S9.995.163 21.985.163s21.71 9.72 21.71 21.71h-.005Z",
    fill: "#FC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.69 21.873v-2h-2v2h2Zm.005 0v2h2v-2h-2Zm-2.005 0c0 10.885-8.825 19.71-19.71 19.71v4c13.094 0 23.71-10.616 23.71-23.71h-4Zm-19.71 19.71c-10.884 0-19.705-8.825-19.705-19.71h-4c0 13.093 10.611 23.71 23.705 23.71v-4ZM2.275 21.873c0-10.885 8.825-19.71 19.71-19.71v-4c-13.094 0-23.71 10.616-23.71 23.71h4Zm19.71-19.71c10.885 0 19.71 8.825 19.71 19.71h4c0-13.094-10.616-23.71-23.71-23.71v4Zm21.71 17.71h-.005v4h.005v-4Z",
    fill: "#222",
    mask: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.257 10.842h-.214v4.305h.214v-4.305Z",
    fill: "#665C7A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.352 10.99h-2.1v1.345h2.1V10.99Z",
    fill: "#F74F17"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.876 29.606H7.433v1.177h29.443v-1.177Z",
    fill: "#CCC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.388 19.48H6.916v10.13h30.472V19.48Z",
    fill: "#DBDBDB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.115 21.254H30.04v2.848h2.076v-2.848Z",
    fill: "#F0F0F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.853 21.521h-1.547v2.313h1.547v-2.313Z",
    fill: "#74AABE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.864 21.254h-2.077v2.848h2.077v-2.848Z",
    fill: "#F0F0F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.601 21.521h-1.547v2.313h1.547v-2.313Z",
    fill: "#74AABE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.115 25.769H30.04v2.848h2.076v-2.848Z",
    fill: "#F0F0F0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.853 26.032h-1.547v2.313h1.547v-2.313Z",
    fill: "#74AABE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.864 25.769h-2.077v2.848h2.077v-2.848Z",
    fill: "#F0F0F0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.601 26.032h-1.547v2.313h1.547v-2.313Z",
    fill: "#74AABE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.864 21.254v.601h-1.422v2.247h-.655v-2.848h2.077ZM32.12 21.254v.601h-1.422v2.247h-.66v-2.848h2.082ZM35.864 25.769v.601h-1.422v2.242h-.655V25.77h2.077ZM32.12 25.769v.601h-1.422v2.242h-.66V25.77h2.082Z",
    fill: "#BEC7C7",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.455 21.254H8.378v2.848h2.077v-2.848Z",
    fill: "#F0F0F0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.149 29.602H16.226v1.185H28.15v-1.185Z",
    fill: "#DEDEDE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.192 21.521H8.645v2.313h1.547v-2.313Z",
    fill: "#74AABE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.203 21.254h-2.077v2.848h2.077v-2.848Z",
    fill: "#F0F0F0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.94 21.521h-1.546v2.313h1.546v-2.313Z",
    fill: "#74AABE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.455 25.769H8.378v2.848h2.077v-2.848Z",
    fill: "#F0F0F0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.192 26.032H8.645v2.313h1.547v-2.313Z",
    fill: "#74AABE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M14.203 25.769h-2.077v2.848h2.077v-2.848Z",
    fill: "#F0F0F0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.94 26.032h-1.546v2.313h1.546v-2.313Z",
    fill: "#74AABE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.203 21.254v.601H12.78v2.247h-.655v-2.848h2.077ZM10.455 21.254v.601H9.033v2.247h-.655v-2.848h2.077ZM14.203 25.769v.601H12.78v2.242h-.655V25.77h2.077ZM10.455 25.769v.601H9.033v2.242h-.655V25.77h2.077Z",
    fill: "#BEC7C7",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28.425 18.259V29.61H15.883V18.26h1.578l4.693-4.248 4.694 4.248h1.577Z",
    fill: "#F2F2F2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26.968 19.73v9.89H17.34v-9.89h.681l4.132-3.74 4.132 3.74h.682Z",
    fill: "#D9DADA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.968 19.73v9.89h-.397v-9.494h-.682l-4.132-3.735-.022-.022.42-.38 4.13 3.74h.683Z",
    fill: "#BEC7C7",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.27
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.517 21.022h-4.73v1.734h4.73v-1.734Z",
    fill: "#F7E83E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M20.67 22.207a.34.34 0 0 1-.067.214.25.25 0 0 1-.125.085.358.358 0 0 1-.102.013.292.292 0 0 1-.179-.053.27.27 0 0 1-.093-.116.497.497 0 0 1-.04-.17l.174-.013c.009.071.026.12.053.152.022.022.045.035.076.035.04 0 .071-.022.093-.058.014-.017.018-.044.018-.08a.221.221 0 0 0-.067-.147c-.035-.036-.089-.085-.16-.151a.712.712 0 0 1-.13-.156.364.364 0 0 1-.04-.17c0-.111.036-.191.112-.25a.265.265 0 0 1 .17-.053c.066 0 .12.013.164.045a.215.215 0 0 1 .085.093c.022.04.036.09.04.138l-.174.032c-.004-.05-.018-.09-.044-.116a.097.097 0 0 0-.072-.032.083.083 0 0 0-.075.045.175.175 0 0 0-.023.09c0 .053.023.11.072.169a.45.45 0 0 0 .08.075c.04.036.071.058.084.076a.538.538 0 0 1 .13.192.29.29 0 0 1 .027.116l.013-.005ZM21.107 22.524a.276.276 0 0 1-.205-.085.276.276 0 0 1-.085-.205v-.655c0-.08.027-.147.085-.205a.294.294 0 0 1 .205-.085c.08 0 .147.027.205.085a.294.294 0 0 1 .084.205v.138h-.187v-.143a.089.089 0 0 0-.031-.071.089.089 0 0 0-.071-.031.104.104 0 0 0-.076.031.095.095 0 0 0-.031.071v.66c0 .027.009.053.03.071a.108.108 0 0 0 .077.032c.03 0 .053-.01.07-.032a.089.089 0 0 0 .032-.071v-.165h.187v.17c0 .08-.026.146-.084.204a.273.273 0 0 1-.2.085l-.005-.004ZM21.722 21.998v.508h-.183v-1.204h.183v.513h.218v-.513h.183v1.204h-.183v-.508h-.218ZM22.569 21.29c.08 0 .147.026.205.084a.294.294 0 0 1 .084.205v.655c0 .08-.026.147-.084.205a.276.276 0 0 1-.205.085.276.276 0 0 1-.205-.085.284.284 0 0 1-.085-.2v-.656a.292.292 0 0 1 .285-.29l.005-.004Zm.098.284a.104.104 0 0 0-.031-.076.117.117 0 0 0-.076-.03c-.031 0-.054.008-.072.03a.098.098 0 0 0-.03.076v.66a.106.106 0 0 0 .102.107.104.104 0 0 0 .076-.031.117.117 0 0 0 .03-.076v-.66ZM23.3 21.29c.08 0 .147.026.205.084a.294.294 0 0 1 .085.205v.655c0 .08-.027.147-.085.205a.276.276 0 0 1-.205.085.276.276 0 0 1-.205-.085.266.266 0 0 1-.085-.2v-.656a.292.292 0 0 1 .285-.29l.005-.004Zm.098.284a.104.104 0 0 0-.031-.076.117.117 0 0 0-.076-.03.098.098 0 0 0-.076.03.098.098 0 0 0-.03.076v.66c0 .031.008.053.03.076a.116.116 0 0 0 .076.03.098.098 0 0 0 .076-.03.117.117 0 0 0 .031-.076v-.66ZM24.244 22.51h-.494v-1.203h.183v1.02h.311v.183ZM24.49 25.278h-4.675v4.346h4.675v-4.346Z",
    fill: "#665C7A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M21.985 25.644h-1.819v3.962h1.819v-3.962ZM24.142 25.644h-1.818v3.962h1.818v-3.962Z",
    fill: "#534B64"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M25.15 29.606h-5.991v.392h5.99v-.392Z",
    fill: "#E5E5E5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M25.568 30.003H18.74v.392h6.828v-.392Z",
    fill: "#F2F2F2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M25.983 30.395H18.32v.392h7.662v-.392Z",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M22.154 20.006c-.722 0-1.31-.589-1.31-1.31 0-.723.588-1.311 1.31-1.311.722 0 1.31.588 1.31 1.31 0 .722-.588 1.31-1.31 1.31Z",
    fill: "#62BDC7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M23.228 18.69a1.075 1.075 0 1 1-2.147-.001 1.075 1.075 0 0 1 2.147.002Z",
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M22.199 18.789a.078.078 0 0 1-.112 0 .078.078 0 0 1 0-.112l.629-.628a.078.078 0 0 1 .111 0 .078.078 0 0 1 0 .111l-.628.629Z",
    fill: "#4D4D4D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M22.177 18.668a.08.08 0 0 1 .026.107.084.084 0 0 1-.107.032l-.44-.254a.085.085 0 0 1-.032-.107.078.078 0 0 1 .107-.027l.441.254.005-.005Z",
    fill: "#4D4D4D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m22.805 19.381-.04.036-.602-.637h-.018a.06.06 0 0 1-.062-.063.06.06 0 0 1 .062-.062.06.06 0 0 1 .063.062v.023l.602.637-.005.005Z",
    fill: "#F17931"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M15.879 19.038H6.613v.442h9.266v-.442ZM37.691 19.038h-9.266v.442h9.266v-.442Z",
    fill: "#E9E8E8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.879 19.48H6.916v.526h8.963v-.526ZM37.388 19.48h-8.963v.526h8.963v-.526Z",
    fill: "#BEC7C7",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.58
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "m24.499 21.017-4.734 1.734v-1.734H24.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.222 29.61v1.177l-8.79-.004v-1.177h-.516V27.22l1.462-1.457 1.662-1.662.415-.415 1.671-1.667.267-.267.228-.232.267-.263 1.253-1.252.525-.526.437-.437h.78L15.88 29.61h.343Z",
    fill: "#BEC7C7",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.871 30.787-12.68 12.68c-.726.076-1.466.112-2.21.112-10.88 0-19.892-8.005-21.465-18.443l6.097-6.098v.442h.303v10.13h.513v1.177H36.87ZM22.038 10.842v3.271l-4.577 4.145h-1.582v.78h-2.042l8.201-8.196Z",
    fill: "#C1C0C6",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColleges1);
export default __webpack_public_path__ + "static/media/colleges 1.afa8896f358ee153aec9e5fb6d0e6d7d.svg";
export { ForwardRef as ReactComponent };